import { useState } from "react";
import axios from "axios";
import { Download, LogIn } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminLeads() {
  const [key, setKey] = useState(sessionStorage.getItem("adminKey") || "");
  const [leads, setLeads] = useState(null);
  const [error, setError] = useState("");

  const load = async (e) => {
    e?.preventDefault();
    setError("");
    try {
      const { data } = await axios.get(`${API}/api/leads`, { headers: { "x-admin-key": key } });
      sessionStorage.setItem("adminKey", key);
      setLeads(data);
    } catch {
      setError("Invalid admin key.");
      setLeads(null);
    }
  };

  const exportCsv = async () => {
    const { data } = await axios.get(`${API}/api/leads/export`, {
      headers: { "x-admin-key": key },
      responseType: "blob",
    });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ecom-bible-leads.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="min-h-screen bg-[#08162B] text-white px-5 sm:px-8 py-16">
      <div className="max-w-5xl mx-auto">
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">The Ecom Bible</p>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl tracking-[0.02em]">LEADS</h1>

        {leads === null ? (
          <form onSubmit={load} className="mt-10 max-w-sm space-y-4" data-testid="admin-login-form">
            <input
              type="password"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              placeholder="Admin key"
              data-testid="admin-key-input"
              className="w-full bg-transparent border-b border-white/25 focus:border-[#D4AF37] outline-none py-3 text-base placeholder:text-white/25"
            />
            {error && <p data-testid="admin-error" className="text-sm text-[#F0A3A3]">{error}</p>}
            <button
              type="submit"
              data-testid="admin-login-button"
              className="inline-flex items-center gap-2 bg-[#D4AF37] text-[#08162B] font-mono uppercase tracking-[0.18em] text-xs px-6 py-3 hover:bg-white transition-colors"
            >
              <LogIn size={14} /> View leads
            </button>
          </form>
        ) : (
          <>
            <div className="mt-10 flex items-center justify-between gap-4">
              <p data-testid="admin-lead-count" className="font-mono text-xs uppercase tracking-[0.2em] text-white/60">
                {leads.length} lead{leads.length === 1 ? "" : "s"}
              </p>
              <button
                onClick={exportCsv}
                data-testid="admin-export-button"
                className="inline-flex items-center gap-2 border border-white/30 font-mono uppercase tracking-[0.18em] text-xs px-5 py-2.5 hover:bg-white hover:text-[#08162B] transition-colors"
              >
                <Download size={14} /> Export CSV
              </button>
            </div>
            <div className="mt-6 overflow-x-auto border border-white/10">
              <table className="w-full text-left text-sm" data-testid="admin-leads-table">
                <thead className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/50 bg-white/5">
                  <tr>
                    <th className="px-4 py-3">Date</th>
                    <th className="px-4 py-3">Name</th>
                    <th className="px-4 py-3">Email</th>
                    <th className="px-4 py-3">Phone</th>
                    <th className="px-4 py-3">Source</th>
                  </tr>
                </thead>
                <tbody>
                  {leads.map((l) => (
                    <tr key={l.id} className="border-t border-white/10">
                      <td className="px-4 py-3 whitespace-nowrap text-white/60">{new Date(l.created_at).toLocaleString()}</td>
                      <td className="px-4 py-3">{l.name}</td>
                      <td className="px-4 py-3"><a href={`mailto:${l.email}`} className="hover:text-[#D4AF37]">{l.email}</a></td>
                      <td className="px-4 py-3 whitespace-nowrap">{l.phone}</td>
                      <td className="px-4 py-3 text-white/60">{l.source}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
